module.exports = __webpack_public_path__ + "assets/img/11.c67ba109.png";